import { createStructuredSelector } from "reselect";
import {
    ARTICLE,
    ARTICLE_SUCCESS,
    ARTICLE_ERROR,
    ARTICLE_CARD_INFO,
    ARTICLE_CARD_INFO_SUCCESS,
    ARTICLE_CARD_INFO_ERROR,
    ARTICLE_CARD_SEARCH_SET,
    ARTICLE_CARD_SEARCH_CHANGE,
    ARTICLE_CARD_TAB_SET
} from "../actions";

export const NAME = 'articleCard';


export const Article = (filters) => ({
    type: ARTICLE,
    payload: { filters: filters }
});

export const ArticleSuccess = (data) => ({
    type: ARTICLE_SUCCESS,
    payload: data
});

export const ArticleError = (error) => ({
    type: ARTICLE_ERROR,
    payload: error
});


export const ArticleCardInfo = (filters, stateFilter) => ({
    type: ARTICLE_CARD_INFO,
    payload: { filters: filters, filtersState: stateFilter }
});

export const ArticleCardInfoSuccess = (data) => ({
    type: ARTICLE_CARD_INFO_SUCCESS,
    payload: data
});

export const ArticleCardInfoError = (error) => ({
    type: ARTICLE_CARD_INFO_ERROR,
    payload: error
});

export const ArticleCardSearchSet = (data) => ({
    type: ARTICLE_CARD_SEARCH_SET,
    payload: data
});

export const ArticleCardSearchChangeSet = (data) => ({
    type: ARTICLE_CARD_SEARCH_CHANGE,
    payload: data
});

export const ArticleCardTabSet = (data) => ({
    type: ARTICLE_CARD_TAB_SET,
    payload: data
});


const articleCard = (state) => state[NAME];

export const ArticleCardSelector = createStructuredSelector({
    articleCard
})
